import { render, staticRenderFns } from "./LinkCard.vue?vue&type=template&id=47b77c83"
import script from "./LinkCard.vue?vue&type=script&lang=js"
export * from "./LinkCard.vue?vue&type=script&lang=js"
import style0 from "./LinkCard.vue?vue&type=style&index=0&id=47b77c83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports